// extracted by mini-css-extract-plugin
export var articlePost = "ArticlePost-module--articlePost--33n6l";
export var postImage = "ArticlePost-module--postImage--3TAOU";